import React from "react";

interface SuccessIconProps {
  className?: string;
  onClick?: () => void;
}

export const SuccessIcon = ({ className, onClick }: SuccessIconProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    onClick={onClick}
  >
    <circle cx="12" cy="12" r="12" fill="#0ABF52" />
    <path
      d="M9.57181 15.0548L6.37339 11.8564L5 13.2298L9.57181 17.8016L19 8.37339L17.6266 7L9.57181 15.0548Z"
      fill="white"
    />
  </svg>
);

SuccessIcon.defaultProps = {
  className: "",
  onClick: undefined,
};
